import { MaterialCategoryGrid } from "../library/MaterialCategoryGrid";

/**
 * The selection-gated material panels, inserted at the TOP of the left rail the
 * moment a mesh is selected and gone again when it is deselected.
 *
 * The reference splits these five ways (Metals · Gems · Ceramics · Pearls ·
 * Other); we group to three. Picking a surface, a ceramic behaves like a metal
 * finish and a pearl belongs with the gems — the five-way split is a taxonomy
 * of how the assets were authored, not of how anyone chooses one.
 *
 * ⚠️ The grouping is in the UI only. Each preset keeps its own `PresetKind`
 * server-side, so the mirror still files ceramics as `ceramic`, nothing needs a
 * data migration, and going back to five is a one-line change.
 *
 * This is the whole point of the wave. Before it, changing a part's metal meant
 * clicking the mesh in the 3D viewport (V1 had no part list at all), then
 * scrolling past eight sections on a right-rail tab. The presets were always
 * there — they were just filed under a collapsed accordion three hundred pixels
 * away on the other side of the screen.
 *
 * No tabs (one category each), no file row (that stays on the right rail's
 * Material Library, which is where the reference keeps it too), and four
 * columns rather than three because a panel is wider than a section.
 */
export const MetalsPanel = () => <MaterialCategoryGrid categories={["metal", "ceramic"]} columns={4} />;
export const GemsPanel = () => <MaterialCategoryGrid categories={["gem", "pearl"]} columns={4} />;
/** Every panel draws its library's sub-category chips (the grid's default);
 *  the reference itself only showed them on Other. */
export const OtherMaterialsPanel = () => (
  <MaterialCategoryGrid categories={["other"]} columns={4} subGroups />
);
